import React from 'react';
import { useTranslation } from 'next-i18next';
import { InstanceProps, create } from 'react-modal-promise';
import { useRouter } from 'next/router';

import Modal from 'components/Modal';
import IconButton from 'components/IconButton';
import { ButtonV3 } from 'components/ComponentV2';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './SignOutModal.module.scss';

const SignOutModal: React.FC<InstanceProps<boolean | undefined>> = (props) => {
  const { isOpen: open, onResolve, onReject } = props;
  const router = useRouter();
  const [tSettings] = useTranslation('candidate.settings');
  const [tCommon] = useTranslation('common');

  const onSignOut = () => {
    router.push(`${PAGE_ROUTES.LOGOUT}?type=candidate`);
    onResolve();
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onReject}
      isFullScreen={false}
      contentClassName={styles['sign-out-modal']}
    >
      <div className={styles.header}>
        <IconButton
          size="small"
          iconName="close"
          className={styles.close}
          onClick={() => onReject()}
        />
      </div>
      <div className={styles.content}>
        <p className={styles.emoji}>😢</p>
        <p className={styles.title}>{tSettings('sign-out-modal.title')}</p>
        <p className={styles.description}>
          {tSettings('sign-out-modal.description')}
        </p>
        <div className={styles.action}>
          <ButtonV3 onClick={onSignOut}>{tCommon('sign-out')}</ButtonV3>
          <ButtonV3 color="secondary" onClick={() => onReject()}>
            {tCommon('cancel')}
          </ButtonV3>
        </div>
      </div>
    </Modal>
  );
};

const SignOutModalInstance = create(SignOutModal);

export default SignOutModalInstance;
